var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-empty',{attrs:{"description":"页面跑火星了，联系管理员"}})}
var staticRenderFns = []

export { render, staticRenderFns }